import { useCallback, useEffect, useState } from "react";
import { DEFAULT_DISPLAY_CURRENCY } from "../constants/currency";
import { normalizeCurrency } from "../services/currency";
import {
  fetchCurrencyPreference,
  saveCurrencyPreferenceToSupabase,
} from "../services/currencyRepository";

const STORAGE_KEY = "orion33_display_currency";

const readStoredCurrency = () => {
  try {
    return normalizeCurrency(
      localStorage.getItem(STORAGE_KEY),
      DEFAULT_DISPLAY_CURRENCY
    );
  } catch {
    return DEFAULT_DISPLAY_CURRENCY;
  }
};

const writeStoredCurrency = (currency) => {
  try {
    localStorage.setItem(STORAGE_KEY, normalizeCurrency(currency));
  } catch {}
};

export default function useCurrencyPreference(userId) {
  const [displayCurrency, setDisplayCurrencyRaw] = useState(readStoredCurrency);

  useEffect(() => {
    if (!userId) {
      setDisplayCurrencyRaw(readStoredCurrency());
      return;
    }

    let canceled = false;
    fetchCurrencyPreference(userId)
      .then(({ data }) => {
        if (canceled || !data?.display_currency) return;
        const nextCurrency = normalizeCurrency(
          data.display_currency,
          DEFAULT_DISPLAY_CURRENCY
        );
        setDisplayCurrencyRaw(nextCurrency);
        writeStoredCurrency(nextCurrency);
      })
      .catch(() => {});

    return () => {
      canceled = true;
    };
  }, [userId]);

  const setDisplayCurrency = useCallback(
    (currency) => {
      const nextCurrency = normalizeCurrency(currency, DEFAULT_DISPLAY_CURRENCY);
      setDisplayCurrencyRaw(nextCurrency);
      writeStoredCurrency(nextCurrency);

      if (userId) {
        saveCurrencyPreferenceToSupabase(userId, nextCurrency).catch(() => {});
      }
    },
    [userId]
  );

  return {
    displayCurrency,
    setDisplayCurrency,
  };
}

